// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavBar_menu__1S14y"};